import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addAccount = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Account',
    // '/api/method/technoerp.services.create_account',
    body
  );
  return data;
});
export const updateAccount = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    // '/api/method/technoerp.services.update_account',
    `/api/resource/Account/${id}`,
    body
  );
  return data;
});
export const getAccountDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.get_account_details?record=${record}`
    `/api/resource/Account/${id}`
  );
  return data;
});
// export const getAccounts = catchAsync(
//   async (
//     pageCount = 1,
//     searchText = '',
//     nameSearch = '',
//     currentLang = 'en'
//   ) => {
//     console.log('searchTextaaaaaaaa', searchText);
//     const { data } = await axiosInstance.get(
//       // '/api/method/technoerp.services.get_accounts'
//       // "api/method/technoerp.services.get_accounts?filters={root_type:Expense}&limit_start=10&limit_page_length=10&page=1"
//       // `api/method/technoerp.services.get_accounts?filters={"root_type":"Expense"}&limit_start=10&limit_page_length=10&page=${pageCount}`
//       // `api/method/technoerp.services.get_accounts?filters={"root_type":"${searchText}"}&limit_start=10&limit_page_length=10&page=${pageCount}`
//       // `api/method/technoerp.services.get_accounts?${
//       // searchText ? `filters={"root_type":"${searchText}"}` : ''
//       // }&limit_start=10&limit_page_length=10&page=${pageCount}`
//       // `/api/resource/Account?fields=["name","account_type","account_currency","report_type","root_type","parent_account","account_name"]&_lang=${currentLang}&filters:{"root_type":"${searchText}"}&limit_start=10&limit_page_length=10&page=${pageCount}`
//       `/api/resource/Account?fields=["name","account_type","account_currency","report_type","root_type","parent_account","account_name"]&_lang=${currentLang}&limit_start=0&limit_page_length=0&page=${pageCount}&filters:{"account_name":"${searchText}"}`
//     );
//     console.log('Fetched accounts data:', data);
//     return data;
//   }
// );
export const getAccounts = catchAsync(
  async (
    pageCount = 1,
    searchText = '',
    nameSearch = '',
    currentLang = 'en'
  ) => {
    // console.log('searchText:', searchText);

    let baseUrl = `/api/resource/Account?fields=["name","account_type","account_currency","report_type","root_type","parent_account","account_name"]&_lang=${currentLang}&limit_start=0&limit_page_length=0&page=${pageCount}`;
    if (searchText) {
      // [["account_name","like","%الأصول%"]]
      // baseUrl += `&filters={"account_name":"${searchText}"}`;
      baseUrl += `&filters=[["account_name","like","%${searchText}%"]]`;
    }
    const { data } = await axiosInstance.get(baseUrl);
    console.log('Fetched accounts data:', data);
    return data;
  }
);

export const getChartAccountParent = catchAsync(async (company) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.search?type=Account&filters:[["docstatus","=","1"]]`
    `/api/method/technoerp.services.search?type=Account&filters:{"is_group":1,"company":"${company}"}`
  );
  return data;
});
export const getAccountsTree = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_chart_of_accounts_tree'
  );
  return data;
});
export const getAccountsBalances = catchAsync(async (labels) => {
  const { data } = await axiosInstance.get(
    // '/api/method/technoerp.services.get_accounts_balances?accounts=["استخدام الاموال (الأصول) - S"]'
    // '/api/method/technoerp.services.get_accounts_balances?accounts=["استخدام الاموال (الأصول) - S","مبيعات - S"]'
    `/api/method/technoerp.services.get_accounts_balances?accounts=[${labels}]`
  );
  return data;
});

export const deleteAccount = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    // `/api/method/technoerp.services.delete_record?record=${record}&document=Account`
    `api/resource/Account/${record}`
  );
  return data;
});
export const editAccountName = catchAsync(
  async ({ account_number, account_name, name }) => {
    const { data } = await axiosInstance.post(
      `/api/method/technoerp.services.update_account_name?account_number=${account_number}&account_name=${account_name}&name=${name}`
    );
    return data;
  }
);
export const convertAccount = catchAsync(async ({ isGroup, docs }) => {
  const { data } = await axiosInstance.post(
    `/api/method/run_doc_method?method=${
      isGroup ? 'convert_group_to_ledger' : 'convert_ledger_to_group'
    }&docs=${JSON.stringify(docs)}`
  );
  return data;
});
